<div class="paginator-container" [style.width]="width">

  <div class="center-center" style="gap: 8px;">
    <p>Itens por página</p>
    <mat-form-field appearance="outline" class="items-per-page-select">
      <mat-select [value]="pageSize" (selectionChange)="alterarTamanhoPagina($event.value)">
        @for (page of pageSizeOptions; track page) {
          <mat-option [value]="page">{{ page }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="center-center">
    <p>{{ infoLabel }}</p>
  </div>

  <div class="center-center" style="gap: 8px;">
    <button mat-icon-button
            matTooltip="Primeira"
            class="center-center"
            [class]="pageIndex === 0 ? 'btn-mudanca-tbl-disabled' : 'btn-mudanca-tbl'"
            (click)="navegar('first')"
            [disabled]="pageIndex === 0">
      <mat-icon>keyboard_double_arrow_left</mat-icon>
    </button>

    <button mat-icon-button
            matTooltip="Anterior"
            class="center-center"
            [class]="pageIndex === 0 ? 'btn-mudanca-tbl-disabled' : 'btn-mudanca-tbl'"
            (click)="navegar('prev')"
            [disabled]="pageIndex === 0">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <button mat-icon-button
            matTooltip="Próxima"
            class="center-center"
            [class]="pageIndex >= (length / pageSize) - 1 ? 'btn-mudanca-tbl-disabled' : 'btn-mudanca-tbl'"
            (click)="navegar('next')"
            [disabled]="pageIndex >= (length / pageSize) - 1">
      <mat-icon>chevron_right</mat-icon>
    </button>

    <button mat-icon-button
            matTooltip="Última"
            class="center-center"
            [class]="pageIndex >= (length / pageSize) - 1 ? 'btn-mudanca-tbl-disabled' : 'btn-mudanca-tbl'"
            (click)="navegar('last')"
            [disabled]="pageIndex >= (length / pageSize) - 1">
      <mat-icon>keyboard_double_arrow_right</mat-icon>
    </button>
  </div>

</div>
